export const TPL_TYPE_COPY_RESV = 0;
export const TPL_TYPE_COPY_FIX_HIME = 1;
export const TPL_TYPE_COPY_FIX_DRIVER = 12;
export const TPL_TYPE_MSG_HIME = 2;
export const TPL_TYPE_MSG_DRIVER = 3;
export const TPL_TYPE_MSG_DRIVER_SEND = 6;
export const TPL_TYPE_MSG_DRIVER_PICK = 7;
export const TPL_TYPE_MSG_FIX_HIME = 8;
export const TPL_TYPE_MSG_FIX_DRIVER = 11;
export const TPL_TYPE_SMS_RESV = 4;
export const TPL_TYPE_SMS_SALES = 5;
export const TPL_TYPE_LINE_RESV = 13;
export const TPL_TYPE_MSG_HIME_WORK = 9;
export const TPL_TYPE_COPY_HIME_WORK = 10;
